<template>
    <div>
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header> 

        <b-card style="margin: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <new-button @click="goToAdd"/>
                    </div>
                </div>
             <b-card-header header-tag="header" class="p-1" role="tab" style="margin-top: 30px"> 
                Filtros
            </b-card-header>
            <b-card-body>
                <div class="row" style="margin-top: 10px">
                    <div class="col-md-6">
                        <label>Nombre</label><br/>   
                        <base-input v-model="filter.BankName"></base-input>
                    </div>
                </div>   
                <div class="row" style="margin-top: 10px">
                    <div class="col-md-6 text-right">
                        <filter-button @click="search"></filter-button>
                    </div>
                </div>
            </b-card-body>
        </b-card>  
       
        <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Bancos
            </b-card-header>
            <b-card-body>
                <div class="row" style="margin-top: 10px">
                    <div class="col-md-12">
                        <download-csv
                            v-if="tableData.length > 0"
                            class   = "btn btn-success btn-sm"
                            :data   = "tableData"
                            :fields = "csv.json_fields"
                            :labels = "csv.labels"
                            :name    = "exportFileName"
                            delimiter = ";">
                            <i class="fa fa-file-excel fa-fw"></i>Exportar
                            
                        
                        </download-csv>
                        <b-table striped hover :items="tableData" :fields="tableFields" class="mt-3" outlined>
                            <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Cargando...</strong> 
                            </div>
                            <template slot="ActionColumn" slot-scope="row">
                                <update-button @click="goToUpdate(row.item.EntityID)"></update-button>
                                <delete-button @click="goToDelete(row.item.EntityID)"></delete-button>
                            </template>
                        </b-table>
                    </div>
                </div>   
            </b-card-body>
        </b-card>  
 
    </div>
</template>

<script>
  import Vue from 'vue'
  import axiosHelpers from '@/helpers/axiosHelpers';
  import notificationHelpers from '@/helpers/notificationHelpers';
  import datetimeHelpers from '@/helpers/datetimeHelpers';
  import JsonCSV from 'vue-json-csv' 
    Vue.component('downloadCsv', JsonCSV)

  export default { 
    name: 'BanksList',
    props: {
      title: String
    },
    components: {},
    
    data() {
      return {
        filter : {
            BankName: ''
        },
        tableData: [],
        tableFields: [
                    { key: 'BankName', label: 'Nombre', sortable: true, sortDirection: 'desc' },
                    { key: 'CBU', label: 'CBU', sortable: true, sortDirection: 'desc' },
                    { key: 'Description', label: 'Descripción', sortable: true, sortDirection: 'desc' },
                    { key: 'ActionColumn', label: 'Acciones' }
                ],
        csv: {
            json_fields: [
                'BankName',
                'CBU',
                'Description'
            ],
            labels: {
                BankName: 'Nombre',
                CBU: 'CBU',
                Description: 'Descripción'
            },
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ]
        }
        /*EntityID, Name, CBU, Description */
      }
    },
    computed: {
        // a computed getter
        exportFileName: function () {
            var d = new Date();
            var datestring = datetimeHelpers.getFormattedDDMMYYYY(d, '');
            var temp = 'Bancos' + datestring + '.csv'; 

            return temp;
        }
    },
    methods: {
        
        goToAdd()
        {
            this.$router.push('agregarModificarBanco') 
        },

        search(){ 
            let self = this;
            axiosHelpers.axiosPost('Supplier/GetSupplierBankAccountList', {BankName: self.filter.BankName}, this, 
                function(response) { 
                    var hasError = axiosHelpers.getResponseHasErrors(response);

                    if(!hasError)
                    {
                        self.tableData = response.ResponseVM; 
                    }
                } 
            );
        },

        goToUpdate(entityID)
        {
            let self = this;
            self.$router.push({
                name: 'agregarModificarBanco', 
                params: { EntityIDProp: entityID }
            });
        },

        async goToDelete(entityID)
        {
            let self = this;
            notificationHelpers.showConfirmation('Confirmar', 'Desea eliminar el Banco?',
                function()
                {
                    axiosHelpers.axiosPost('Supplier/DeleteSupplierBankAccount', {EntityID: entityID}, self, 
                        function(response) { 
                            var hasError = axiosHelpers.getResponseHasErrors(response);

                            if(!hasError)
                            {
                                notificationHelpers.showSuccess('Exito', 'Se ha eliminado correctamente el Banco.', self); 
                                self.search();
                            }
                            
                        } );
                }
            , null, this);            
        }
    },
    mounted() {
        
    }

  };

 
</script>
<style></style>
